export const GET_DISCLAIMER_PENDING = "GET_DISCLAIMER_PENDING";
export const GET_DISCLAIMER_FULFILLED = "GET_DISCLAIMER_FULFILLED";
export const GET_DISCLAIMER_REJECTED = "GET_DISCLAIMER_REJECTED";

export const SAVE_DISCLAIMER_CHECK_PENDING = "SAVE_DISCLAIMER_CHECK_PENDING";
export const SAVE_DISCLAIMER_CHECK_FULFILLED = "SAVE_DISCLAIMER_CHECK_FULFILLED";
export const SAVE_DISCLAIMER_CHECK_REJECTED = "SAVE_DISCLAIMER_CHECK_REJECTED";

export const RESET_DISCLAIMER = "RESET_DISCLAIMER";
